const createId = ({ nowDate = new Date() } = {}) =>
  `${nowDate.getTime()}.${Math.random().toString().slice(2)}`;

export default createId;
